import * as Yup from 'yup';

export const validationSchemaPrice = Yup.object().shape({
  name: Yup.string()
    .required('Price Sheet Name Is Required')
    // .test(
    //   'is-valid-companyName',
    //   'Invalid Product Name',
    //   (value) => !value || /^[a-zA-Z0-9&\-',./ ]+$/.test(value)
    // )
    .max(100, 'Price Name must be at most 100 characters'),
    // startDate: Yup.string()
    // .required('Start Date is required')
    // .typeError('Invalid date format'),
    // endDate: Yup.date()
    // .required('End Date is required')
    // .typeError('Invalid date format')
    startDate: Yup.date()
    .required('Start Date is required')
    .typeError('Invalid date format'),

  endDate: Yup.date()
    .required('End Date is required')
    .typeError('Invalid date format')
    .min(
      Yup.ref('startDate'),
      'End Date cannot be before Start Date'
    ),
});
